import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import AgencyLogin from "Auth/AgencyLogin/AgencyLogin";
import { selectUserInfo } from "../src/redux/userSlice";
import { useSelector } from "react-redux";
import Home from "Pages/Home/Home";
import Navbar from "components/Home/Navbar/Navbar";
import Flight from "Pages/Flight/Flight";
import Oneway from "components/Home/FlightRoutes/Oneway";
import MultiCity from "components/Home/FlightRoutes/MultiCity";
import RoundTrip from "components/Home/FlightRoutes/RoundTrip";
import HomeHotel from "Pages/Hotel/HomeHotel";
import EnquaryHistory from "components/EnquaryHistory/EnquaryHistory";
import HotelEnquiryHistory from "views/admin/CRM/Hotel/HotelEnquiryHistory";
import ChatApp from "views/admin/CRM/Chat/ChatApp";
import Enquiry from "Pages/Home/InstagramEnquiryFrom/Enquiry";
import { IoIosChatbubbles, IoMdCloseCircle } from "react-icons/io";
import Feedbackform from "Pages/Home/Feedback/Feedbackform";
import Creditcardauthorizationform from "Pages/Home/CREDITCARDAUTHORIZATIONFORM/Creditcardauthorizationform";
import HistoryOtherEnquiry from "views/admin/CRM/Other/HistoryOtherEnquiry";
import InvoiceHistory from "views/admin/Invoice/InvoiceHistory";
import InvoiceList from "views/admin/Invoice/InvoiceList";
import TwilioWhatsAppChat from "components/twilio/whatsapp/TwilioWhatsAppChat";

const App = () => {
  const navigate = useNavigate(); // lowercase 'n'
  const location = useLocation();
  const userInfo = useSelector(selectUserInfo);
  const messages = useSelector((state) => state?.messages);
  const twilioMessages = useSelector((state) => state.twilioMessages);
  // useEffect(() => {
  // }, [twilioMessages]);
  console.log("userInfo", userInfo);

  const [isChatOpen, setIsChatOpen] = useState(false);

  const [isVisible, setIsVisible] = useState(true);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  const adminRole = Number(process.env.REACT_APP_ROLE_ADMIN);
  const employeeRole = Number(process.env.REACT_APP_ROLE_EMPLOYEE);
  const superAdminRole = Number(process.env.REACT_APP_ROLE_SUPERADMIN);

  const isAdmin =
    userInfo?.data?.role_id === adminRole ||
    userInfo?.data?.role_id === employeeRole ||
    userInfo?.data?.role_id === superAdminRole;

  // Scroll event handler to toggle visibility
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); // Detect mobile devices

    const handleBackButton = () => {
      if (isMobile && isChatOpen) {
        setIsChatOpen(false); // Close chat instead of navigating back
        window.history.pushState(null, "", window.location.href); // Prevent back navigation
      }
    };

    if (isMobile) {
      window.addEventListener("popstate", handleBackButton);
    }

    return () => {
      if (isMobile) {
        window.removeEventListener("popstate", handleBackButton);
      }
    };
  }, [isChatOpen]);

  // useEffect(() => {
  //   document.body.style.overflow = "hidden"; // Disable scrolling
  //   return () => {
  //     document.body.style.overflow = ""; // Restore scrolling
  //   };
  // }, []);

  // useEffect(() => {
  //   // Disable scrolling when chat is open
  //   if (isChatOpen) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     // Restore scrolling when chat is closed
  //     document.body.style.overflow = "";
  //   }

  //   // Clean up function to restore scrolling on component unmount or when isChatOpen changes
  //   return () => {
  //     document.body.style.overflow = "";
  //   };
  // }, [isChatOpen]); // Dependency array ensures effect runs when isChatOpen changes

  return (
    <>
      {isAdmin ? (
        <>
          <div className="fixed bottom-20 right-10 z-50">
            <div className="relative">
              <div
                className="cursor-pointer overflow-hidden rounded-full p-2"
                onClick={toggleChat}
              >
                {isChatOpen ? (
                  <IoMdCloseCircle size={35} className="text-red-500" />
                ) : (
                  <IoIosChatbubbles size={35} className="text-green-500" />
                )}
              </div>
              <div className="absolute -top-2 right-1 text-red-500">
                {messages.length > 0 && <p>{messages.length}</p>}
              </div>
            </div>
          </div>

          {isChatOpen && (
            <div className="fixed z-50 h-full w-full overflow-hidden border border-gray-300 bg-white shadow-lg sm:bottom-36 sm:right-10 sm:h-auto sm:w-[600px] sm:rounded-lg">
              <ChatApp toggleChat={toggleChat} />
            </div>
          )}

          <Routes>
            <Route
              path="/"
              element={<Navigate to="/admin/default" replace />}
            />
            <Route
              path="/dashboard"
              element={<Navigate to="/admin" replace />}
            />
            <Route path="auth/*" element={<AuthLayout />} />
            <Route path="admin/*" element={<AdminLayout />} />
            <Route path="admin/enquiry-history" element={<EnquaryHistory />} />
            <Route
              path="admin/hotel-enquiry-history"
              element={<HotelEnquiryHistory />}
            />
            <Route
              path="admin/other-enquiry-history"
              element={<HistoryOtherEnquiry />}
            />
            <Route path="admin/invoice-list" element={<InvoiceList />} />
            <Route path="admin/invoice-history" element={<InvoiceHistory />} />
            <Route path="/whatsapp" element={<TwilioWhatsAppChat />} />

            {/* <Route path="/admin/chat-app/:username" element={<ChatApp />} /> */}

            {/* <Route path="/create-enquiry" element={<CreateEnquiry />}>
            <Route index element={<RoundTrip />} />
            <Route path="oneWay" element={<OneWay />} />
            <Route path="round-trip" element={<RoundTrip />} />
            <Route path="multi-city" element={<MultiCity />} />
          </Route> */}
          </Routes>
        </>
      ) : (
        <>
          {/* {location.pathname !== "/" && <Navbar />} */}
          <Routes>
            {/* <Route path="/" element={<Home />}>
              <Route index element={<Flight />} />
              <Route path="/flights" element={<Flight />}>
                <Route index element={<RoundTrip />} />
                <Route path="oneWay" element={<Oneway />} />
                <Route path="round-trip" element={<RoundTrip />} />
                <Route path="multi-city" element={<MultiCity />} />
              </Route>
              <Route path="/hotels" element={<HomeHotel />} />
              <Route path="/hotdeals" element={<Hotdeals />} />
            </Route> */}
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="admin/*" element={<Navigate to="/" replace />} />
            <Route path="auth/*" element={<Navigate to="/" replace />} />
            <Route path="/" element={<AgencyLogin />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/feedback" element={<Feedbackform />} />
            {/* <Route path="/whatsapp" element={<TwilioWhatsAppChat />} /> */}
            <Route
              path="/credit-card-authorization"
              element={<Creditcardauthorizationform />}
            />
          </Routes>
        </>
      )}
    </>
  );
};

export default App;
